/** Utility > Dispatch Barcode Lookup. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { BarcodeLookupPage } from "@/features/sales-dispatch/components/barcode-lookup-page";

export const Route = createFileRoute("/_app/dispatch/barcode-lookup")({
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: BarcodeLookupPage,
});
